import type { SearchFilters } from '@content-search/domain';
import { useCallback } from 'react';

import { SearchInput } from './SearchInput';
import * as styles from './StickySearchPanel.css';

export interface StickySearchPanelProps {
  isVisible: boolean;
  onSearch: (filters: SearchFilters) => void;
  isLoading?: boolean;
  searchFilters: SearchFilters;
  setSearchFilters: (filters: SearchFilters) => void;
}

export function StickySearchPanel({ isVisible, onSearch, isLoading = false, searchFilters, setSearchFilters }: StickySearchPanelProps) {
  const updateSearchFilters = useCallback(
    (updates: Partial<SearchFilters>) => {
      setSearchFilters({
        ...searchFilters,
        ...updates,
        panelFilters: updates.panelFilters ? { ...searchFilters.panelFilters, ...updates.panelFilters } : searchFilters.panelFilters,
      });
    },
    [searchFilters, setSearchFilters]
  );

  return (
    <div aria-label="Search control bar" className={styles.controlBarContainer} data-visible={isVisible} role="banner">
      <div className={styles.controlBarContent}>
        <SearchInput
          isStickyPanel
          isFiltersPanelOpen={false}
          isLoading={isLoading}
          searchFilters={searchFilters}
          updateSearchFilters={updateSearchFilters}
          onSearch={onSearch}
        />
      </div>
    </div>
  );
}
